// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .angular-editor-textarea,
::ng-deep .p-editor-container {
  background: #fff !important;
}

.library-upload-view .input {
  height: 2rem !important;
  font-size: 0.9rem !important;
}
.library-upload-view .questionnarie {
  width: 98%;
  margin: 0.9rem auto;
  padding: 1rem 1.5rem !important;
  border: 1px solid #d4d4d4;
  background: #fafafa !important;
}
.library-upload-view .questionnarie .has-text-danger {
  font-size: 0.9rem !important;
}
.library-upload-view .questionnarie .input {
  width: 100% !important;
}
.library-upload-view .questionnarie .icon {
  margin-left: 10px;
}
.library-upload-view .questionnarie .pi-trash,
.library-upload-view .questionnarie .pi-trash {
  color: #f14668 !important;
}
.library-upload-view .questionnarie .radio {
  font-size: 0.9rem;
}
.library-upload-view .question-option .has-text-danger {
  font-size: 0.9rem !important;
}
.library-upload-view .question-option .radio-group {
  width: 30px !important;
}
.library-upload-view .question-option .input {
  width: 80% !important;
}
.library-upload-view .question-option .fa,
.library-upload-view .question-option .fa:hover {
  color: #f14668 !important;
}
.library-upload-view .flex-container .flex-item {
  width: 100%;
  max-height: 78vh;
}
.library-upload-view .flex-container .flex-item .card #questiontopic::placeholder {
  color: rgb(182, 182, 182) !important;
  text-transform: capitalize;
  font-size: 1rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body {
  overflow-y: auto;
  min-height: 50vh;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img {
  width: 100% !important;
  height: 100px !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img img {
  width: 60px !important;
  border-radius: 0px !important;
  box-shadow: none !important;
  min-width: 50px !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .file-cta {
  width: 150px;
  height: 100px;
  display: flex;
  justify-content: center;
  background-color: transparent !important;
  color: transparent !important;
  border-color: transparent !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .file-cta .file-icon {
  justify-content: center;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .file-cta .file-icon .fa-solid {
  font-size: 6rem !important;
  color: var(--primaryColor) !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .img-options {
  background: none !important;
  right: 0px !important;
  border-radius: 0% !important;
  text-align: left !important;
  left: 0px;
  top: 0px !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .img-options .fa {
  color: #000 !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .img-options .upload-file-form {
  height: calc(100vh - 150px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.library-upload-view .flex-container .flex-item .card .card-body .profile-img .img-options .container {
  height: calc(100vh - 220px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.library-upload-view .flex-container .flex-item .card .card-body .responsiveRadioBtn {
  margin: 10px 0;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section {
  padding: 1rem 2rem 0rem 0rem;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .removeAssQuestion {
  float: right;
  top: -32px;
  text-align: center;
  color: var(--whiteColor);
  cursor: pointer;
  position: relative;
  right: -29px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .removeAssQuestion:hover {
  color: #d62e2e !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .tabs ul {
  font-size: 15px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie {
  margin-bottom: 20px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .tabs li.is-active a {
  border-bottom-color: var(--primaryColor) !important;
  color: var(--primaryColor) !important;
  font-weight: 700;
  font-size: 14px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-choice {
  padding: 1rem 2rem 1rem 2rem;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .questionOption {
  padding: 0rem 0rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option {
  padding: 1rem 9rem 3rem 2rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control {
  margin-bottom: 10px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .removeOptions {
  float: right;
  top: 5px;
  width: 30px;
  height: 30px;
  text-align: center;
  color: var(--whiteColor);
  cursor: pointer;
  position: absolute;
  right: -69px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .removeOptions:hover {
  color: #d62e2e !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label::before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio].is-danger + label:before {
  border: 3px solid #f14668;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio],
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio] + label:first-of-type,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox] + label:first-of-type {
  float: right;
  position: absolute;
  margin-left: 10px;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:before {
  animation-name: none;
  border: 0.1rem solid #dbdbdb;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label::after,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=radio]:checked + label:after,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label::after,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option .control .is-checkradio[type=checkbox]:checked + label:after {
  display: inline-block;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .survey_question .is-checkradio[type=checkbox] + label {
  font-size: 1rem !important;
  padding-left: 2rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .survey_question .is-checkradio[type=checkbox] + label::before,
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .survey_question .is-checkradio[type=checkbox] + label:before {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarieAns {
  padding: 2rem 0rem;
  margin-top: -7%;
}
.library-upload-view .flex-container .flex-item .card .card-body .columns .file-label {
  text-align: left !important;
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox] {
  outline: 0;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 0;
  padding-right: 3.5rem;
  cursor: pointer;
  font-weight: bold;
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success:checked + label::before,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success:checked + label:before {
  background: var(--primaryColor);
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-sucess + label::before,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label:before {
  left: auto;
  right: -0.375rem;
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label::before,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox] + label:before {
  position: absolute;
  display: block;
  top: 0;
  left: auto;
  right: 0.25rem;
  width: 3rem;
  height: 1.5rem;
  border: 0.1rem solid transparent;
  border-radius: 4px;
  background: #b5b5b5;
  content: "";
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label::after,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox].is-success + label:after {
  display: block;
  position: absolute;
  top: 0.25rem;
  left: auto;
  right: 1.425rem;
  width: 1rem;
  height: 1rem;
  transform: translate3d(0, 0, 0);
  border-radius: 4px;
  background: var(--whiteColor);
  transition: all 0.25s ease-out;
  content: "";
}
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked.is-success + label::after,
.library-upload-view .flex-container .flex-item .card .card-body .switch[type=checkbox]:checked.is-success + label:after {
  left: auto;
  right: 0;
}
.library-upload-view .flex-container .flex-item .card .card-footer {
  padding: 0.3rem;
}
.library-upload-view .flex-container .flex-item .card .card-footer footer {
  min-height: 40px !important;
  height: 40px !important;
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish {
  width: 100% !important;
  margin-left: 26px;
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish .responsiveRadioBtn {
  margin: 20px 0;
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label {
  position: relative;
  display: initial;
  font-size: 1rem;
  line-height: initial;
  padding-left: 0;
  padding-right: 3.5rem;
  cursor: pointer;
  font-weight: bold;
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox] + label::before {
  position: absolute;
  display: block;
  top: 0;
  left: auto;
  right: -0.375rem;
  width: 3rem;
  height: 1.5rem;
  border: 0.1rem solid transparent;
  border-radius: 4px;
  background: #b5b5b5;
  content: "";
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonPublish .switch[type=checkbox].is-success + label:after {
  display: block;
  position: absolute;
  top: 0.25rem;
  left: auto;
  right: 1.425rem;
  width: 1rem;
  height: 1rem;
  transform: translate3d(0, 0, 0);
  border-radius: 4px;
  background: var(--whiteColor);
  transition: all 0.25s ease-out;
  content: "";
}
.library-upload-view .flex-container .flex-item .card .card-footer .lessonSubmitBtn {
  position: absolute;
  top: 5px;
  right: 0px;
}

.library-upload-view .upload-file-form {
  height: calc(100vh - 260px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.library-upload-view .container-file {
  height: calc(100vh - 350px);
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
}
.library-upload-view .card .card-body .questionnaries {
  border-left: 1px solid #acacac;
}
.library-upload-view .tabs.stepper li a,
.library-upload-view .tabs.stepper li.is-active a {
  border: none !important;
}

.tabs:not(.stepper) li span {
  display: none;
}

.tabs.stepper {
  padding: 0.3rem 5rem !important;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;
}
.tabs.stepper li {
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-right: 10px;
}
.tabs.stepper li a {
  padding: 0px 5px 0px 5px;
}
.tabs.stepper li span.check-mark,
.tabs.stepper li span.edit {
  display: none;
}
.tabs.stepper li.is-active {
  opacity: 1;
}
.tabs.stepper li.is-active span:not(.line-horizontal) {
  background: var(--primaryColor) !important;
}
.tabs.stepper li.is-active a {
  color: var(--primaryColor) !important;
}
.tabs.stepper li.is-active span {
  display: none;
}
.tabs.stepper li.is-active span.line-horizontal {
  display: inline-block;
}
.tabs.stepper li.is-active span.edit {
  display: inline-block;
}
.tabs.stepper li.is-active span {
  background: var(--primaryColor) !important;
}
.tabs.stepper li.is-active a {
  color: var(--primaryColor) !important;
}
.tabs.stepper li.complete {
  opacity: 1;
}
.tabs.stepper li.complete span {
  background: #3BBFA1 !important;
}
.tabs.stepper li.complete span {
  display: none;
}
.tabs.stepper li.complete span.line-horizontal {
  display: inline-block;
}
.tabs.stepper li.complete span.check-mark {
  display: inline-block;
  background: #3BBFA1 !important;
  color: #fff !important;
}
.tabs.stepper li.complete span.line-horizontal {
  border: 1px solid #3BBFA1 !important;
}
.tabs.stepper li.complete a {
  color: #3BBFA1 !important;
}
.tabs.stepper li span:not(.line-horizontal) {
  background: #626262;
  text-align: center;
  padding: 3px 10px;
  color: #fffdfd;
  border-radius: 100%;
}
.tabs.stepper li span.line-horizontal {
  border: 1px solid var(--primaryColor) !important;
  width: 100%;
  margin-top: 5px;
}

.tabs {
  padding: 0rem 0rem;
  height: 50px !important;
  min-height: 50px !important;
}
.tabs ul {
  border-bottom-width: 0px !important;
}
.tabs .tab {
  pointer-events: none;
  opacity: 0.5;
}
.tabs .tab.is-active {
  opacity: 1;
  pointer-events: none;
}

.assessment-lock {
  pointer-events: none !important;
}

@media screen and (max-width: 320px) and (max-width: 767px) {
  .library-upload-view .flex-container .flex-item .card .card-body {
    max-height: calc(100vh - 293px);
    overflow-x: hidden;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .tabs ul {
    font-size: 15px !important;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .tabs li.is-active a {
    border-bottom-color: var(--primaryColor) !important;
    color: var(--primaryColor) !important;
    font-weight: 700;
    font-size: 14px;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option {
    padding: 1rem 0rem 3rem 2rem;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .angular-editor-wrapper .angular-editor-textarea {
    padding: 0.5rem 1.8rem 1rem !important;
  }
  .library-upload-view .flex-container .flex-item .card .card-body {
    max-height: calc(100vh - 293px);
    overflow-x: hidden;
  }
  .library-upload-view .flex-container .flex-item .card .card-body section.section .questionnarie .question-option {
    padding: 1rem 0rem 3rem 1rem !important;
  }
}
.lessonSubmitBtn.disabled {
  pointer-events: none !important;
}

/**************radio button***************/
.radio-group {
  width: 250px !important;
}

.radio {
  margin: 0.5rem;
}
.radio input[type=radio] {
  position: absolute;
  opacity: 0;
}
.radio input[type=radio] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.1em;
  margin-right: 0.5em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type=radio]:checked + .radio-label:before {
  background-color: #3197EE;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type=radio]:focus + .radio-label:before {
  outline: none;
  border-color: #3197EE;
}
.radio input[type=radio]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type=radio] + .radio-label:empty:before {
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/elibraryandcourse/e-library/e-library-details/e-library-upload/e-library-upload.component.scss"],"names":[],"mappings":"AAAA;;EAEE,2BAAA;AACF;;AAIE;EACE,uBAAA;EACA,4BAAA;AADJ;AAIE;EAEE,UAAA;EACA,mBAAA;EACA,+BAAA;EACA,yBAAA;EACA,8BAAA;AAHJ;AAKI;EACE,4BAAA;AAHN;AAMI;EACE,sBAAA;AAJN;AAOI;EACE,iBAAA;AALN;AAQI;;EAEE,yBAAA;AANN;AASI;EACE,iBAAA;AAPN;AAYI;EACE,4BAAA;AAVN;AAaI;EACE,sBAAA;AAXN;AAcI;EACE,qBAAA;AAZN;AAeI;;EAEE,yBAAA;AAbN;AA0BI;EACE,WAAA;EACA,gBAAA;AAxBN;AA2BQ;EACE,oCAAA;EACA,0BAAA;EACA,0BAAA;AAzBV;AA4BQ;EACE,gBAAA;EACA,gBAAA;AA1BV;AA6BU;EACE,sBAAA;EACA,wBAAA;AA3BZ;AA6BY;EACE,sBAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;AA3Bd;AA8BY;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,wCAAA;EACA,6BAAA;EACA,oCAAA;AA5Bd;AA8Bc;EACE,uBAAA;AA5BhB;AA8BgB;EACE,0BAAA;EACA,qCAAA;AA5BlB;AAiCY;EACE,2BAAA;EACA,qBAAA;EACA,4BAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;AA/Bd;AAiCc;EACE,sBAAA;AA/BhB;AAkCc;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;AAhChB;AAmCc;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;AAjChB;AAsCU;EACE,cAAA;AApCZ;AAuCU;EACE,4BAAA;AArCZ;AAuCY;EACE,YAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AArCd;AAuCc;EACE,yBAAA;AArChB;AA2CgB;EACE,eAAA;AAzClB;AAgDY;EAEE,mBAAA;AA/Cd;AAkDc;EACE,mDAAA;EACA,qCAAA;EACA,gBAAA;EACA,eAAA;AAhDhB;AAmDc;EACE,4BAAA;AAjDhB;AAoDc;EACE,6BAAA;AAlDhB;AAqDc;EACE,uCAAA;AAnDhB;AAqDgB;EACE,mBAAA;AAnDlB;AAqDkB;EACE,YAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAnDpB;AAqDoB;EACE,yBAAA;AAnDtB;AAuDkB;;EAEE,yBAAA;AArDpB;AAwDkB;;EAEE,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AAtDpB;AAyDkB;;EAEE,YAAA;EACA,kBAAA;EACA,iBAAA;AAvDpB;AA0DkB;;;;EAIE,oBAAA;EACA,4BAAA;AAxDpB;AA2DkB;;;;EAIE,qBAAA;AAzDpB;AA+DgB;EACE,0BAAA;EACA,6BAAA;AA7DlB;AAgEgB;;EAEE,wBAAA;EACA,yBAAA;AA9DlB;AAmEY;EACE,kBAAA;EACA,eAAA;AAjEd;AAsEY;EACE,2BAAA;AApEd;AAwEU;EACE,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AAtEZ;AAyEU;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AAvEZ;AA0EU;;EAEE,+BAAA;AAxEZ;AA2EU;;EAEE,UAAA;EACA,gBAAA;AAzEZ;AA4EU;;EAEE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AA1EZ;AAkFU;;EAEE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,WAAA;AAhFZ;AAmFU;;EAEE,UAAA;EACA,QAAA;AAjFZ;AAqFQ;EACE,eAAA;AAnFV;AAqFU;EACE,2BAAA;EACA,uBAAA;AAnFZ;AAsFU;EACE,sBAAA;EACA,iBAAA;AApFZ;AAsFY;EACE,cAAA;AApFd;AAuFY;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;AArFd;AAwFY;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAtFd;AAyFY;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,WAAA;AAvFd;AA2FU;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAzFZ;;AAkGE;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;AA/FJ;AAkGE;EACE,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAhGJ;AAmGE;EACE,8BAAA;AAjGJ;AAoGE;;EAEE,uBAAA;AAlGJ;;AAuGE;EACE,aAAA;AApGJ;;AAwGA;EAEE,+BAAA;EACA,4DAAA;AAtGF;AAwGE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAtGJ;AAwGI;EACE,wBAAA;AAtGN;AAyGI;;EAEE,aAAA;AAvGN;AA0GI;EACE,UAAA;AAxGN;AA0GM;EACE,0CAAA;AAxGR;AA2GM;EACE,qCAAA;AAzGR;AA4GM;EACE,aAAA;AA1GR;AA6GM;EACE,qBAAA;AA3GR;AA8GM;EACE,qBAAA;AA5GR;AA+GM;EACE,0CAAA;AA7GR;AAgHM;EACE,qCAAA;AA9GR;AAkHI;EACE,UAAA;AAhHN;AAkHM;EACE,8BAAA;AAhHR;AAmHM;EACE,aAAA;AAjHR;AAoHM;EACE,qBAAA;AAlHR;AAqHM;EACE,qBAAA;EACA,8BAAA;EACA,sBAAA;AAnHR;AAsHM;EACE,oCAAA;AApHR;AAuHM;EACE,yBAAA;AArHR;AAyHI;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAvHN;AA0HI;EACE,gDAAA;EACA,WAAA;EACA,eAAA;AAxHN;;AAgIA;EACE,kBAAA;EACA,uBAAA;EACA,2BAAA;AA7HF;AA+HE;EACE,mCAAA;AA7HJ;AAgIE;EACE,oBAAA;EACA,YAAA;AA9HJ;AAiIE;EACE,UAAA;EACA,oBAAA;AA/HJ;;AAmIA;EACE,+BAAA;AAhIF;;AAoIA;EAKU;IACE,+BAAA;IACA,kBAAA;EArIV;EA4IgB;IACE,0BAAA;EA1IlB;EA8Ic;IACE,mDAAA;IACA,qCAAA;IACA,gBAAA;IACA,eAAA;EA5IhB;EA+Ic;IACE,4BAAA;EA7IhB;EAiJgB;IACE,sCAAA;EA/IlB;EAgKQ;IACE,+BAAA;IACA,kBAAA;EA9JV;EAoKc;IACE,uCAAA;EAlKhB;AACF;AA8KA;EACE,+BAAA;AA5KF;;AA+KA,0CAAA;AAIA;EACE,uBAAA;AA/KF;;AAkLA;EACE,cAAA;AA/KF;AAiLE;EACE,kBAAA;EACA,UAAA;AA/KJ;AAkLM;EACE,WAAA;EACA,mBAjBC;EAkBD,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAhLR;AAsLQ;EACE,yBAnCD;EAoCC,mCAAA;AApLV;AA2LQ;EACE,aAAA;EACA,qBA7CD;AA5IT;AAgMQ;EACE,mCAAA;EACA,qBAAA;EACA,mBAAA;AA9LV;AAqMQ;EACE,eAAA;AAnMV","sourcesContent":["::ng-deep .angular-editor-textarea,\n::ng-deep .p-editor-container {\n  background: #fff !important;\n}\n\n.library-upload-view {\n\n  .input {\n    height: 2rem !important;\n    font-size: .9rem !important;\n  }\n\n  .questionnarie {\n    // box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px !important;\n    width: 98%;\n    margin: .9rem auto;\n    padding: 1rem 1.5rem !important;\n    border: 1px solid #d4d4d4;\n    background: #fafafa !important;\n\n    .has-text-danger {\n      font-size: .9rem !important;\n    }\n\n    .input {\n      width: 100% !important;\n    }\n\n    .icon {\n      margin-left: 10px;\n    }\n\n    .pi-trash,\n    .pi-trash {\n      color: #f14668 !important;\n    }\n\n    .radio {\n      font-size: .9rem;\n    }\n  }\n\n  .question-option {\n    .has-text-danger {\n      font-size: .9rem !important;\n    }\n\n    .radio-group {\n      width: 30px !important;\n    }\n\n    .input {\n      width: 80% !important;\n    }\n\n    .fa,\n    .fa:hover {\n      color: #f14668 !important;\n    }\n\n    // .is-checkradio[type=radio] + label:first-of-type{\n    //   margin-left:10px;\n    // }\n    // .is-checkradio[type=radio] + label, .is-checkradio[type=checkbox] + label {\n\n    //   padding:0.2rem .8rem !important;\n    // }\n  }\n\n  .flex-container {\n    .flex-item {\n      width: 100%;\n      max-height: 78vh;\n\n      .card {\n        #questiontopic::placeholder {\n          color: rgb(182, 182, 182) !important;\n          text-transform: capitalize;\n          font-size: 1rem !important;\n        }\n\n        .card-body {\n          overflow-y: auto;\n          min-height: 50vh;\n          // max-height: calc(70vh);\n\n          .profile-img {\n            width: 100% !important;\n            height: 100px !important;\n\n            img {\n              width: 60px !important;\n              border-radius: 0px !important;\n              box-shadow: none !important;\n              min-width: 50px !important;\n            }\n\n            .file-cta {\n              width: 150px;\n              height: 100px;\n              display: flex;\n              justify-content: center;\n              background-color: transparent !important;\n              color: transparent !important;\n              border-color: transparent !important;\n\n              .file-icon {\n                justify-content: center;\n\n                .fa-solid {\n                  font-size: 6rem !important;\n                  color: var(--primaryColor) !important;\n                }\n              }\n            }\n\n            .img-options {\n              background: none !important;\n              right: 0px !important;\n              border-radius: 0% !important;\n              text-align: left !important;\n              left: 0px;\n              top: 0px !important;\n\n              .fa {\n                color: #000 !important;\n              }\n\n              .upload-file-form {\n                height: calc(100vh - 150px);\n                overflow-y: scroll;\n                overflow-x: hidden;\n              }\n\n              .container {\n                height: calc(100vh - 220px);\n                overflow-y: scroll;\n                overflow-x: hidden;\n              }\n            }\n          }\n\n          .responsiveRadioBtn {\n            margin: 10px 0;\n          }\n\n          section.section {\n            padding: 1rem 2rem 0rem 0rem;\n\n            .removeAssQuestion {\n              float: right;\n              top: -32px;\n              text-align: center;\n              color: var(--whiteColor);\n              cursor: pointer;\n              position: relative;\n              right: -29px;\n\n              &:hover {\n                color: #d62e2e !important;\n              }\n            }\n\n            .questionnarie {\n              .tabs {\n                ul {\n                  font-size: 15px;\n                }\n              }\n\n\n            }\n\n            .questionnarie {\n              // border-bottom: 1px solid #b5b5b5;\n              margin-bottom: 20px;\n\n\n              .tabs li.is-active a {\n                border-bottom-color: var(--primaryColor) !important;\n                color: var(--primaryColor) !important;\n                font-weight: 700;\n                font-size: 14px;\n              }\n\n              .question-choice {\n                padding: 1rem 2rem 1rem 2rem;\n              }\n\n              .questionOption {\n                padding: 0rem 0rem !important;\n              }\n\n              .question-option {\n                padding: 1rem 9rem 3rem 2rem !important;\n\n                .control {\n                  margin-bottom: 10px;\n\n                  .removeOptions {\n                    float: right;\n                    top: 5px;\n                    width: 30px;\n                    height: 30px;\n                    text-align: center;\n                    color: var(--whiteColor);\n                    cursor: pointer;\n                    position: absolute;\n                    right: -69px;\n\n                    &:hover {\n                      color: #d62e2e !important;\n                    }\n                  }\n\n                  .is-checkradio[type=\"radio\"].is-danger+label::before,\n                  .is-checkradio[type=\"radio\"].is-danger+label:before {\n                    border: 3px solid #f14668;\n                  }\n\n                  .is-checkradio[type=\"radio\"],\n                  .is-checkradio[type=\"checkbox\"] {\n                    outline: 0;\n                    user-select: none;\n                    display: inline-block;\n                    position: absolute;\n                    opacity: 0;\n                  }\n\n                  .is-checkradio[type=\"radio\"]+label:first-of-type,\n                  .is-checkradio[type=\"checkbox\"]+label:first-of-type {\n                    float: right;\n                    position: absolute;\n                    margin-left: 10px;\n                  }\n\n                  .is-checkradio[type=\"radio\"]:checked+label::before,\n                  .is-checkradio[type=\"radio\"]:checked+label:before,\n                  .is-checkradio[type=\"checkbox\"]:checked+label::before,\n                  .is-checkradio[type=\"checkbox\"]:checked+label:before {\n                    animation-name: none;\n                    border: 0.1rem solid #dbdbdb;\n                  }\n\n                  .is-checkradio[type=\"radio\"]:checked+label::after,\n                  .is-checkradio[type=\"radio\"]:checked+label:after,\n                  .is-checkradio[type=\"checkbox\"]:checked+label::after,\n                  .is-checkradio[type=\"checkbox\"]:checked+label:after {\n                    display: inline-block;\n                  }\n                }\n              }\n\n              .survey_question {\n                .is-checkradio[type=\"checkbox\"]+label {\n                  font-size: 1rem !important;\n                  padding-left: 2rem !important;\n                }\n\n                .is-checkradio[type=\"checkbox\"]+label::before,\n                .is-checkradio[type=\"checkbox\"]+label:before {\n                  width: 1.5rem !important;\n                  height: 1.5rem !important;\n                }\n              }\n            }\n\n            .questionnarieAns {\n              padding: 2rem 0rem;\n              margin-top: -7%;\n            }\n          }\n\n          .columns {\n            .file-label {\n              text-align: left !important;\n            }\n          }\n\n          .switch[type=\"checkbox\"] {\n            outline: 0;\n            user-select: none;\n            display: inline-block;\n            position: absolute;\n            opacity: 0;\n          }\n\n          .switch[type=\"checkbox\"]+label {\n            position: relative;\n            display: initial;\n            font-size: 1rem;\n            line-height: initial;\n            padding-left: 0;\n            padding-right: 3.5rem;\n            cursor: pointer;\n            font-weight: bold;\n          }\n\n          .switch[type=\"checkbox\"].is-success:checked+label::before,\n          .switch[type=\"checkbox\"].is-success:checked+label:before {\n            background: var(--primaryColor);\n          }\n\n          .switch[type=\"checkbox\"].is-sucess+label::before,\n          .switch[type=\"checkbox\"].is-success+label:before {\n            left: auto;\n            right: -0.375rem;\n          }\n\n          .switch[type=\"checkbox\"]+label::before,\n          .switch[type=\"checkbox\"]+label:before {\n            position: absolute;\n            display: block;\n            top: 0;\n            left: auto;\n            right: 0.25rem;\n            width: 3rem;\n            height: 1.5rem;\n            border: 0.1rem solid transparent;\n            border-radius: 4px;\n            background: #b5b5b5;\n            content: \"\";\n          }\n\n          // .switch[type=\"checkbox\"].is-success+label::after, .switch[type=\"checkbox\"].is-success+label:after {\n          //   left: auto;\n          //   right: .25rem;\n          // }\n\n          .switch[type=\"checkbox\"].is-success+label::after,\n          .switch[type=\"checkbox\"].is-success+label:after {\n            display: block;\n            position: absolute;\n            top: 0.25rem;\n            left: auto;\n            right: 1.425rem;\n            width: 1rem;\n            height: 1rem;\n            transform: translate3d(0, 0, 0);\n            border-radius: 4px;\n            background: var(--whiteColor);\n            transition: all 0.25s ease-out;\n            content: \"\";\n          }\n\n          .switch[type=\"checkbox\"]:checked.is-success+label::after,\n          .switch[type=\"checkbox\"]:checked.is-success+label:after {\n            left: auto;\n            right: 0;\n          }\n        }\n\n        .card-footer {\n          padding: .3rem;\n\n          footer {\n            min-height: 40px !important;\n            height: 40px !important;\n          }\n\n          .lessonPublish {\n            width: 100% !important;\n            margin-left: 26px;\n\n            .responsiveRadioBtn {\n              margin: 20px 0;\n            }\n\n            .switch[type=\"checkbox\"]+label {\n              position: relative;\n              display: initial;\n              font-size: 1rem;\n              line-height: initial;\n              padding-left: 0;\n              padding-right: 3.5rem;\n              cursor: pointer;\n              font-weight: bold;\n            }\n\n            .switch[type=\"checkbox\"]+label::before {\n              position: absolute;\n              display: block;\n              top: 0;\n              left: auto;\n              right: -0.375rem;\n              width: 3rem;\n              height: 1.5rem;\n              border: 0.1rem solid transparent;\n              border-radius: 4px;\n              background: #b5b5b5;\n              content: \"\";\n            }\n\n            .switch[type=\"checkbox\"].is-success+label:after {\n              display: block;\n              position: absolute;\n              top: 0.25rem;\n              left: auto;\n              right: 1.425rem;\n              width: 1rem;\n              height: 1rem;\n              transform: translate3d(0, 0, 0);\n              border-radius: 4px;\n              background: var(--whiteColor);\n              transition: all 0.25s ease-out;\n              content: \"\";\n            }\n          }\n\n          .lessonSubmitBtn {\n            position: absolute;\n            top: 5px;\n            right: 0px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.library-upload-view {\n  .upload-file-form {\n    height: calc(100vh - 260px);\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n\n  .container-file {\n    height: calc(100vh - 350px);\n    overflow-y: scroll;\n    overflow-x: hidden;\n    width: 100%;\n  }\n\n  .card .card-body .questionnaries {\n    border-left: 1px solid #acacac;\n  }\n\n  .tabs.stepper li a,\n  .tabs.stepper li.is-active a {\n    border: none !important;\n  }\n}\n\n.tabs:not(.stepper) {\n  li span {\n    display: none;\n  }\n}\n\n.tabs.stepper {\n\n  padding: .3rem 5rem !important;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px !important;\n\n  li {\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    margin-right: 10px;\n\n    a {\n      padding: 0px 5px 0px 5px;\n    }\n\n    span.check-mark,\n    span.edit {\n      display: none;\n    }\n\n    &.is-active {\n      opacity: 1;\n\n      span:not(.line-horizontal) {\n        background: var(--primaryColor) !important;\n      }\n\n      a {\n        color: var(--primaryColor) !important;\n      }\n\n      span {\n        display: none;\n      }\n\n      span.line-horizontal {\n        display: inline-block;\n      }\n\n      span.edit {\n        display: inline-block;\n      }\n\n      span {\n        background: var(--primaryColor) !important;\n      }\n\n      a {\n        color: var(--primaryColor) !important;\n      }\n    }\n\n    &.complete {\n      opacity: 1;\n\n      span {\n        background: #3BBFA1 !important;\n      }\n\n      span {\n        display: none;\n      }\n\n      span.line-horizontal {\n        display: inline-block;\n      }\n\n      span.check-mark {\n        display: inline-block;\n        background: #3BBFA1 !important;\n        color: #fff !important;\n      }\n\n      span.line-horizontal {\n        border: 1px solid #3BBFA1 !important;\n      }\n\n      a {\n        color: #3BBFA1 !important;\n      }\n    }\n\n    span:not(.line-horizontal) {\n      background: #626262;\n      text-align: center;\n      padding: 3px 10px;\n      color: #fffdfd;\n      border-radius: 100%;\n    }\n\n    span.line-horizontal {\n      border: 1px solid var(--primaryColor) !important;\n      width: 100%;\n      margin-top: 5px;\n    }\n  }\n\n\n\n}\n\n.tabs {\n  padding: 0rem 0rem;\n  height: 50px !important;\n  min-height: 50px !important;\n\n  ul {\n    border-bottom-width: 0px !important;\n  }\n\n  .tab {\n    pointer-events: none;\n    opacity: 0.5;\n  }\n\n  .tab.is-active {\n    opacity: 1;\n    pointer-events: none;\n  }\n}\n\n.assessment-lock {\n  pointer-events: none !important;\n}\n\n\n@media screen and (max-width:320px) and (max-width:767px) {\n  .library-upload-view {\n    .flex-container {\n      .flex-item {\n        .card {\n          .card-body {\n            max-height: calc(100vh - 293px);\n            overflow-x: hidden;\n\n            section.section {\n\n              // .section{\n              .questionnarie {\n                .tabs {\n                  ul {\n                    font-size: 15px !important;\n                  }\n                }\n\n                .tabs li.is-active a {\n                  border-bottom-color: var(--primaryColor) !important;\n                  color: var(--primaryColor) !important;\n                  font-weight: 700;\n                  font-size: 14px;\n                }\n\n                .question-option {\n                  padding: 1rem 0rem 3rem 2rem;\n                }\n\n                .angular-editor-wrapper {\n                  .angular-editor-textarea {\n                    padding: 0.5rem 1.8rem 1rem !important;\n                  }\n                }\n              }\n\n              // }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .library-upload-view {\n    .flex-container {\n      .flex-item {\n        .card {\n          .card-body {\n            max-height: calc(100vh - 293px);\n            overflow-x: hidden;\n\n            section.section {\n\n              // .section{\n              .questionnarie {\n                .question-option {\n                  padding: 1rem 0rem 3rem 1rem !important;\n                }\n              }\n\n              // }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.lessonSubmitBtn.disabled {\n  pointer-events: none !important;\n}\n\n/**************radio button***************/\n$color1: #f4f4f4;\n$color2: #3197EE;\n\n.radio-group {\n  width: 250px !important;\n}\n\n.radio {\n  margin: 0.5rem;\n\n  input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n\n    +.radio-label {\n      &:before {\n        content: '';\n        background: $color1;\n        border-radius: 100%;\n        border: 1px solid darken($color1, 25%);\n        display: inline-block;\n        width: 1.4em;\n        height: 1.4em;\n        position: relative;\n        top: -0.1em;\n        margin-right: .5em;\n        vertical-align: top;\n        cursor: pointer;\n        text-align: center;\n        transition: all 250ms ease;\n      }\n    }\n\n    &:checked {\n      +.radio-label {\n        &:before {\n          background-color: $color2;\n          box-shadow: inset 0 0 0 4px $color1;\n        }\n      }\n    }\n\n    &:focus {\n      +.radio-label {\n        &:before {\n          outline: none;\n          border-color: $color2;\n        }\n      }\n    }\n\n    &:disabled {\n      +.radio-label {\n        &:before {\n          box-shadow: inset 0 0 0 4px $color1;\n          border-color: darken($color1, 25%);\n          background: darken($color1, 25%);\n        }\n      }\n    }\n\n    +.radio-label {\n      &:empty {\n        &:before {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
